import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MessageChat from "../../components/ChatBot/MessageChat";
import "../../css/User/Message.css";
import "../../css/User/media-message.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faSearch,
  faEllipsis,
  faPenToSquare,
  faCircleChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import TopHeader from "../../components/comman/TopHeader";
import { getSocket } from "../../socket/Socket";
import { FaPlus, FaSpinner } from "react-icons/fa6";
import api from "../../api/axios";
import { logout, getCurrentUserId } from "../../utils/auth";
import { MdKeyboardVoice } from "react-icons/md";
import { FaRegCirclePause } from "react-icons/fa6";
import { MdDeleteOutline } from "react-icons/md";
import { VscDebugStart } from "react-icons/vsc";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import EmojiPicker from "emoji-picker-react";
import { BsEmojiSmile } from "react-icons/bs";

function Message() {
  const location = useLocation();
  let fullName = location.state?.fullName;
  let ProfileImg = location.state?.profilePic;
  let userStatus = location.state?.messageStatus;
  const followingStatus = location.state?.followingStatus;
  const canMessage =
    userStatus === "CAN_MESSAGE" || followingStatus === "FOLLOWING";
  const { userId: routeUserId } = useParams();
  const { userId: userID } = useParams();
  const currentUserId = getCurrentUserId();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [isSendMessage, setSendMessage] = useState();
  const [isSearch, setIsSearch] = useState("");
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const ChatTab = ["All", "Requested"];
  const [isResize, setIsResise] = useState(false);
  const [message, setMessage] = useState("");
  const [isChats, setChats] = useState([]);
  const [isNavigate, setIsNavigate] = useState();
  const [isChatUser, setIsChatUser] = useState([]);
  const [isChatUserList, setIsChatUserList] = useState([]);
  const [CurrentConversationId, setCurrentConversationId] = useState();
  const [LoadChats, setLoadChats] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
  const [isTab, setIsTab] = useState();
  const [isActive, setIsActive] = useState();
  const [ActiveChat, setActiveChat] = useState();
  const [isRequested, setIsRequested] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [typing, setTyping] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isActiveDropDown, setisActiveDropDown] = useState();
  const [swipeStart, setSwipeStart] = useState(null);
  const [isRequestedType, setIsRequestedType] = useState(null);
  const [isRecordingToggle, setIsRecordignTOggle] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [isRecording, setIsRecording] = useState();
  const [timerInterval, setTimerInterval] = useState(null);
  const [loadingRequestId, setLoadingRequestId] = useState(null);
  const [loadingAction, setLoadingAction] = useState(null);
  const [openKebabId, setOpenKebabId] = useState(null);
  const [requestCount, setRequestCount] = useState(0); 
  const [showEmojiPicker, setShowEmojiPicker] = useState(false); 
  const [chatPopupMsg, setChatPopupMsg] = useState(""); 
  const [showChatPopup, setShowChatPopup] = useState(false); 
  const UserChatDropDown = useRef(null);
  const emojiRef = useRef(null);

  // Add this ref near your other refs
  const isNavigatingBack = useRef(false);

  const chatHeaderUser =
    ActiveChat?.user?.fullName ||
    ActiveChat?.from?.fullName ||
    fullName ||
    "Select a chat";
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    setActiveChat(userID);
  }, []);


  useEffect(() =>{
    const handleClickOutside = (event) => {
      if(UserChatDropDown.current && !UserChatDropDown.current.contains(event.target)) {
        setisActiveDropDown(false);
      }
    }
    document.addEventListener("mousedown" , handleClickOutside)
    return()=>{
      document.removeEventListener("mousedown" , handleClickOutside)
    }
  },[])


  const handleEmojiClick = (emojiData) => {
    setMessage((prev) => prev + emojiData.emoji);
  };

  const isOnlyEmoji = (text) => {
    if (!text) return false;

    // remove spaces
    const trimmed = text.trim();

    // emoji regex (covers most emojis)
    const emojiRegex =
      /^(\p{Extended_Pictographic}|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)+$/u;

    return emojiRegex.test(trimmed);
  };

  const emojiCount = (text) => {
    if (!text) return 0;
    const matches = text.match(/\p{Extended_Pictographic}/gu);
    return matches ? matches.length : 0;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiRef.current && !emojiRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // create the timer

  useEffect(() => {
    if (isRecordingToggle) {
      setIsRecording(true);
      const internal = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
      setTimerInterval(internal);
    } else {
      clearInterval(timerInterval);
      setRecordingTime(0);
    }
    return () => clearInterval(timerInterval);
  }, [isRecordingToggle]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  // handle pause recording

  const handlePauseRecording = () => {
    setIsRecording(false);
    clearInterval(timerInterval);
  };

  // handle start recording

  const handleStartRecording = () => {
    setIsRecording(true);
    const interval = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);

    setTimerInterval(interval);
  };

  const chats = [];

  // filter searching user

  useEffect(() => {
    const handleSearch = () => {
      const search = isSearch.toLowerCase();
      const searchUser = isChatUserList.filter((chat) =>
        chat.user?.fullName?.toLowerCase().includes(search),
      );
      setFilteredUsers(searchUser);
    };
    handleSearch();
  }, [isSearch, isChatUserList]);

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Allow images and videos (WhatsApp style)
    const isImage = file.type.startsWith("image/");
    const isVideo = file.type.startsWith("video/");

    if (!isImage && !isVideo) {
      alert("Only image and video files allowed");
      return;
    }

    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [LoadChats, isChats]);

  useEffect(() => {
    setIsChatUser(isChats);
  }, []);

  useEffect(() => {
    const searchText = isSearch.toLowerCase();

    const FilterChat = chats.filter(
      (u) =>
        u.name.toLowerCase().includes(searchText) ||
        u.message.toLowerCase().includes(searchText),
    );
    setIsChatUser(FilterChat);
  }, [isSearch]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const UserNavigate = () => {
    if (isMobile) {
      navigate("/chat-message");
    }
  };

  useEffect(() => {
    const activeUserId = ActiveChat?.user?._id;

    if (!activeUserId) return;
    if (routeUserId !== activeUserId) {
      navigate(`/message/${activeUserId}`, { replace: true });
    }
  }, [ActiveChat, routeUserId, navigate]);

  const handleDeleteMessages = async () => {
    if (selectedMessages.length === 0) {
      alert("Please select at least one message to delete");
      return;
    }

    if (!window.confirm(`Delete ${selectedMessages.length} message(s)?`)) {
      return;
    }

    try {
      await api.post(`/messages/delete`, {
        messageIds: selectedMessages,
      });

      setChats((prev) =>
        prev.filter((msg) => !selectedMessages.includes(msg._id)),
      );
      setLoadChats((prev) =>
        prev.filter((msg) => !selectedMessages.includes(msg._id)),
      );
      // SIDEBAR INSTANT Delete UPDATE
      setIsChatUserList((prevList) =>
        prevList.map((chat) => {
          if (
            String(chat.conversationId) !== String(ActiveChat?.conversationId)
          ) {
            return chat;
          }

          const remainingMessages = LoadChats.filter(
            (msg) => !selectedMessages.includes(msg._id),
          );

          const lastMsg = remainingMessages[remainingMessages.length - 1];

          return {
            ...chat,
            lastMessage: lastMsg || null,
          };
        }),
      );
      setSelectedMessages([]);
    } catch (error) {
      console.error("Failed to delete messages:", error);
      alert("Failed to delete messages. Please try again.");
    }
  };

  const toggleMessageSelection = (messageId) => {
    setSelectedMessages((prev) =>
      prev.includes(messageId)
        ? prev.filter((id) => id !== messageId)
        : [...prev, messageId],
    );
  };

  const handleDeleteChat = async (conversationId) => {
    try {
      await api.post(`/messages/delete/${conversationId}`);
      setIsChatUserList((prev) =>
        prev.filter((chat) => chat.conversationId !== conversationId),
      );
      if (ActiveChat?.conversationId === conversationId) {
        setActiveChat(null);
      }
      setContextMenu(null);
    } catch (error) {
      console.error("Failed to delete chat:", error);
      alert("Failed to delete chat. Please try again.");
    }
  };

  const handleContextMenu = (e, chat) => {
    e.preventDefault();
    setContextMenu({
      chatId: chat.conversationId,
      x: e.clientX,
      y: e.clientY,
    });
  };

  // create block api intigration

  const handleBlockStatus = async () => {
    if (!userID) return;
    try {
      const res = await api.get(`/block-message/block-status/${userID}`);
      console.log(res.data, "block status response");
      setIsBlocked(res.data.blocked);
    } catch (error) {
      console.log("somethink went wrong", error);
    }
  };

  useEffect(() => {
    if (userID) {
      handleBlockStatus();
    }
  }, [userID]);

  const handleBlockChat = async () => {
    try {
      await api.post(`/block-message/block/${userID}`);
      await handleBlockStatus();
    } catch (error) {
      console.log("somethink went wrong", error);
    }
  };

  const handleUnBlock = async () => {
    try {
      await api.post(`/block-message/unblock/${userID}`);
      await handleBlockStatus();
    } catch (error) {
      console.log("somethink went wrong", error);
    }
  };

  const handleTouchStart = (e) => {
    setSwipeStart({
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    });
  };

  const handleTouchEnd = (e, chat) => {
    if (!swipeStart) return;

    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;
    const diffX = swipeStart.x - endX;
    const diffY = swipeStart.y - endY;

    // Detect swipe (horizontal movement more than vertical)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      // Show confirmation alert
      if (window.confirm("Delete this chat?")) {
        handleDeleteChat(chat.conversationId);
      }
    }

    setSwipeStart(null);
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setContextMenu(null);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSendChat = async () => {
    if (!message.trim() && !selectedImage) return;
    if (!userID || !ActiveChat?.conversationId) {
      console.log(userID, "userid");
    }

    const socket = getSocket();
    socket.emit("stop_typing", {
      to: userID,
      conversationId: ActiveChat?.conversationId,
    });
    try {
      const formData = new FormData();
      formData.append("text", message);
      formData.append("conversationId", ActiveChat.conversationId);
      if (selectedImage) formData.append("image", selectedImage);

      const response = await api.post(`/messages/send/${userID}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data?.message) {
        const newMessage = response.data.message;

        setChats((prev) => [...prev, newMessage]);
        setLoadChats((prev) => [...prev, newMessage]);

        // INSTANT MOVE CHAT TO TOP (MAIN FIX)
        setIsChatUserList((prevList) => {
          const updatedList = [...prevList];
          const convId = String(ActiveChat.conversationId);

          const index = updatedList.findIndex(
            (chat) => String(chat.conversationId) === convId,
          );

          if (index === -1) return prevList;

          const chat = updatedList[index];

          const updatedChat = {
            ...chat,
            lastMessage: newMessage,
            updatedAt: newMessage.createdAt,
            unreadCount: 0,
            unread: false,
          };

          // Remove from old position
          updatedList.splice(index, 1);

          // Add to top
          updatedList.unshift(updatedChat);

          return updatedList;
        });
      }

      setImagePreview("");
      setMessage("");
      setSelectedImage(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (error) {
      setChatPopupMsg(
        "Message not sent. You can only chat with users who follow each other or message request has been accepted!"
      );
      setShowChatPopup(true);
    }
  };

  useEffect(() => {
    const handleUserMessage = async () => {
      try {
        const response = await api.get(`/messages/conversations`);

        let conversations = response.data.conversations || [];
        
        // Filter out conversations where user is null (FIX: prevents the error)
        conversations = conversations.filter(chat => chat?.user !== null && chat?.user !== undefined);
        
        setIsChatUserList(conversations);
        if (conversations.length > 0) {
          setCurrentConversationId(conversations[0]._id);
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          logout();
          navigate("/login");
          return;
        }
      }
    };
    handleUserMessage();
  }, [navigate]);

  // FIXED: Added safety check for null user
  // useEffect(() => {
  //   if (!userID || !isChatUserList.length) {
  //     return;
  //   }

  //   const selectedChat = isChatUserList.find(
  //     (chat) => chat?.user?._id && String(chat.user._id) === String(userID),
  //   );

  //   if (!selectedChat) {
  //     return;
  //   }

  //   // Only set if it's actually different
  //   if (
  //     ActiveChat &&
  //     String(ActiveChat.conversationId) === String(selectedChat.conversationId)
  //   ) {
  //     return;
  //   }

  //   console.log(" Auto-selecting chat for userID:", userID);
  //   setActiveChat(selectedChat);
  // }, [userID, isChatUserList, ActiveChat]);

  useEffect(() => {
    if (isNavigatingBack.current) return;
    if (!userID || !isChatUserList.length) return;

    const selectedChat = isChatUserList.find(
      (chat) => chat?.user?._id && String(chat.user._id) === String(userID),
    );

    if (!selectedChat) return;

    setActiveChat((prev) => {
      if (
        prev &&
        String(prev.conversationId) === String(selectedChat.conversationId)
      ) {
        return prev;
      }
      return selectedChat;
    });

  }, [userID, isChatUserList]); // ← ActiveChat removed from deps

  useEffect(() => {
    const handleGeMessage = async () => {
      if (!ActiveChat?.conversationId) {
        setLoadChats([]);
        setChats([]);
        return;
      }

      try {
        const response = await api.get(
          `/messages/${ActiveChat.conversationId}/`,
        );
        setLoadChats(response.data.messages);
        setChats(response.data.messages);
      } catch (error) {
        if (error?.response?.status === 401) {
          logout();
          navigate("/login");
          return;
        }
      }
    };
    handleGeMessage();
  }, [ActiveChat?.conversationId, navigate]);

  const handleRequest = async () => {
    try {
      const response = await api.get("/message-requests/me");
      const requests = response.data.requests || [];
      setIsRequested(response.data.requests);
      setIsRequestedType(response.data?.type);
      setRequestCount(response.data.count || requests.length);
    } catch (error) {
      console.log("Something went wrong", error);
    }
  };

  const currentRequest = isRequested.find((r) => r.from._id === userID);
  const isThisChatARequest = currentRequest;

  const handleRequestAccepte = async (req) => {
    try {
      setLoadingRequestId(req._id);
      setLoadingAction("accept");

      await api.post(`/message-requests/${req._id}/accept`);

      setIsRequested((prev) => prev.filter((r) => r._id !== req._id));
      setRequestCount((prev) => Math.max(prev - 1, 0));

      setTimeout(async () => {
        const res = await api.get(`/messages/conversations`);
        console.log("After Accept Conversations:", res.data.conversations);
        let conversations = res.data.conversations || [];

        const acceptedUserId = req.from._id;

        const rohanConversation = conversations.find(
          (c) => String(c?.user?._id) === String(acceptedUserId),
        );

        if (rohanConversation) {
          conversations = [
            rohanConversation,
            ...conversations.filter(
              (c) => String(c?._id) !== String(rohanConversation._id),
            ),
          ];

          setIsChatUserList(conversations);
          setActiveChat(rohanConversation);
          setCurrentConversationId(rohanConversation._id);
          navigate(`/message/${acceptedUserId}`, { replace: true });
        } else {
          setIsChatUserList(conversations);
          navigate(`/message/${acceptedUserId}`, { replace: true });
        }

        setActiveTab("All");
      }, 700);
    } catch (error) {
      console.error("Accept Error:", error?.response?.data || error);
    } finally {
      setLoadingRequestId(null);
      setLoadingAction(null);
    }
  };

  const handleRequestReject = async (req) => {
    if (!req?._id) return;

    try {
      setLoadingRequestId(req._id);
      setLoadingAction("reject");

      await api.post(`/message-requests/${req._id}/reject`);

      setIsRequested((prev) => prev.filter((r) => r._id !== req._id));
      setRequestCount((prev) => Math.max(prev - 1, 0));
    } catch (error) {
      console.error("Reject request failed:", error);
      alert("Failed to reject request");
    } finally {
      setLoadingRequestId(null);
      setLoadingAction(null);
    }
  };

  const handleDeleteRequest = (reqId) => {
    setIsRequested((prev) => prev.filter((r) => r._id !== reqId));
    setOpenKebabId(null);
  };

  const handleViewProfile = (userId) => {
    navigate(`/profile/${userId}`);
    setOpenKebabId(null);
  };

  const handleBlockFromRequest = async (userId) => {
    try {
      await api.post(`/block-message/block/${userId}`);
      setIsRequested((prev) => prev.filter((r) => r.from._id !== userId));
      setOpenKebabId(null);
    } catch (err) {
      console.log("Block failed", err);
    }
  };

  useEffect(() => {
    handleRequest();
  }, []);

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const handleInboxMessage = (data) => {
      const newMessage = data?.message;
      if (!newMessage) return;

      setIsChatUserList((prevList) => {
        const updatedList = [...prevList];

        const messageConvId = String(newMessage.conversation);
        const index = updatedList.findIndex(
          (chat) => String(chat.conversationId) === messageConvId,
        );

        if (index === -1) return prevList;

        const chat = updatedList[index];

        const isCurrentChat =
          String(ActiveChat?.conversationId) === messageConvId;

        const updatedChat = {
          ...chat,
          lastMessage: newMessage,
          updatedAt: newMessage.createdAt,
          unreadCount: isCurrentChat ? 0 : (chat.unreadCount || 0) + 1,
          unread: !isCurrentChat,
        };

        updatedList.splice(index, 1);
        updatedList.unshift(updatedChat);

        return updatedList;
      });
    };

    socket.on("new_message", handleInboxMessage);
    return () => socket.off("new_message", handleInboxMessage);
  }, [ActiveChat?.conversationId]);

  const handleTyping = (message) => {
    setMessage(message);
    const socket = getSocket();
    socket.emit("typing", {
      to: userID,
      conversationId: ActiveChat?.conversationId,
    });
    socket.on("user_typing", (data) => {
      if (data?.conversationId === ActiveChat?.conversationId) {
        setTyping(true);
      }
      setTimeout(() => {
        socket.emit("stop_typing", {
          to: userID,
          conversationId: ActiveChat?.conversationId,
        });
        setTyping(false);
      }, 1000);
    });
    socket.on("user_stop_typing", (data) => {
      setTyping(false);
    });
    return () => {
      socket.off("user_stop_typing");
      socket.off("user_typing");
    };
  };

  useEffect(() => {
    const socket = getSocket();

    if (!socket) {
      return;
    }

    let retryCount = 0;
    const maxRetries = 10;

    const checkAndJoin = () => {
      if (socket.connected && currentUserId) {
        socket.emit("join", currentUserId);
        retryCount = 0;
        return;
      }

      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(checkAndJoin, 500);
      } else {
        console.warn("Failed to join personal room after retries");
      }
    };

    checkAndJoin();
    const handleReconnect = () => {
      if (currentUserId) {
        socket.emit("join", currentUserId);
      }
    };

    socket.on("connect", handleReconnect);

    return () => {
      socket.off("connect", handleReconnect);
    };
  }, [currentUserId]);

  useEffect(() => {
    const socket = getSocket();

    if (!socket) {
      return;
    }

    if (!ActiveChat?.conversationId) {
      return;
    }

    const conversationId = String(ActiveChat.conversationId);
    const joinConversation = () => {
      if (socket.connected) {
        socket.emit("leave_conversation_all");

        setTimeout(() => {
          socket.emit("join_conversation", conversationId);
        }, 100);
      } else {
        setTimeout(joinConversation, 500);
      }
    };

    const handleReconnect = () => {
      joinConversation();
    };
    joinConversation();
    socket.on("connect", handleReconnect);

    return () => {
      socket.off("connect", handleReconnect);
      socket.emit("leave_conversation", conversationId);
    };
  }, [ActiveChat?.conversationId]);

  useEffect(() => {
    const socket = getSocket();

    if (!socket) {
      return;
    }

    if (
      !ActiveChat?.conversationId ||
      String(ActiveChat.conversationId).startsWith("temp")
    ) {
      return;
    }

    const conversationId = String(ActiveChat.conversationId);

    const handleNewMessage = (data) => {
      const newMessage = data?.message;

      if (!newMessage) {
        return;
      }

      const messageConversationId = String(newMessage.conversation);
      if (messageConversationId !== conversationId) {
        return;
      }
      setLoadChats((prev) => {
        const exists = prev.some(
          (m) => String(m._id) === String(newMessage._id),
        );
        if (exists) return prev;
        return [...prev, newMessage];
      });

      setChats((prev) => {
        const exists = prev.some(
          (m) => String(m._id) === String(newMessage._id),
        );
        if (exists) return prev;
        return [...prev, newMessage];
      });

      setIsChatUserList((prevList) =>
        prevList.map((chat) => {
          const chatConvId = String(chat.conversationId);
          if (chatConvId === messageConversationId) {
            return {
              ...chat,
              lastMessage: newMessage,
              updatedAt: newMessage.createdAt,
              unreadCount: 0,
              unread: false,
            };
          }
          return chat;
        }),
      );
    };
    const handleReconnect = () => {
      socket.emit("leave_conversation_all");
      setTimeout(() => {
        socket.emit("join_conversation", conversationId);
      }, 100);
    };

    const handleDisconnect = () => { };

    socket.on("new_message", handleNewMessage);
    socket.on("connect", handleReconnect);
    socket.on("disconnect", handleDisconnect);

    return () => {
      socket.off("new_message", handleNewMessage);
      socket.off("connect", handleReconnect);
      socket.off("disconnect", handleDisconnect);
    };
  }, [ActiveChat?.conversationId]);

  return (
    <div className="page-wrapper">
      <div className="page-top-container">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
      </div>

      <div className="Mesenger_Container">
        <div className="messenger-wrapper">
          {(!isMobile || !ActiveChat) && (
            <div className="messenger_left">
              <div className="chats-header">
                <div className="chats_sidebar_header">
                  <button
                    className="chat-page-back-button"
                    onClick={() => {
                      setActiveChat(null);
                      navigate(-1, { replace: true });
                    }}
                  >
                    <FontAwesomeIcon icon={faCircleChevronLeft} />
                  </button>
                  <h2>Chats</h2>
                </div>
              </div>

              <div className="messenger-search">
                <FontAwesomeIcon icon={faSearch} />
                <input
                  onChange={(e) => setIsSearch(e.target.value)}
                  type="text"
                  placeholder="Search Messenger"
                />
              </div>

              <div className="chat-tabs01">
                {ChatTab.map((item, idx) => (
                  <span
                    key={idx}
                    className={
                      activeTab === item
                        ? "active-chat-tab position-relative"
                        : "position-relative"
                    }
                    onClick={() => {
                      setActiveTab(item);

                      if (item === "Requested") {
                        setRequestCount(0);
                        handleRequest();
                      }
                    }}
                  >
                    {item}

                    {item === "Requested" && requestCount > 0 && (
                      <h2
                        className="message_request_count_number ms-1"
                      >
                        {requestCount}
                      </h2>
                    )}
                  </span>
                ))}
              </div>

              <div className="chat-list">
                {activeTab !== "Requested" ? (
                  (isSearch ? filteredUsers : isChatUserList).map(
                    (chat, idx) => (
                      <div
                        key={idx}
                        className={`chat-item ${chat.unread ? "unread" : ""}`}
                        onClick={() => {
                          setActiveChat(chat);
                          if (chat?.user?._id && String(chat.user._id) !== String(userID)) {
                            navigate(`/message/${chat.user._id}`, {
                              replace: true,
                            });
                          }
                        }}
                        onContextMenu={(e) => handleContextMenu(e, chat)}
                        onTouchStart={handleTouchStart}
                        onTouchEnd={(e) => handleTouchEnd(e, chat)}
                      >
                        <div className="chat-avatar">
                          <img
                            src={
                              chat?.user?.profilePic
                                ? `${chat?.user?.profilePic}`
                                : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                            }
                            alt="user"
                            className="message-avatar"
                            onError={(e) => {
                              e.target.src =
                                "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                            }}
                          />
                        </div>
                        <div className="chat-info">
                          <div className="chat-top">
                            <span className="chat-name">
                              {chat?.user?.fullName || "Unknown User"}
                            </span>
                            <span className="chat-time">
                              {chat.lastMessage?.createdAt ? 
                                new Date(chat.lastMessage.createdAt).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }) : ""
                              }
                            </span>
                          </div>
                          <div className="chat-message">
                            {chat.lastMessage?.text || "No messages yet"}
                          </div>
                        </div>

                        {chat.unreadCount > 0 && (
                          <span className="unread-badge">
                            {chat.unreadCount}
                          </span>
                        )}
                      </div>
                    ),
                  )
                ) : isRequested.length === 0 ? (
                  <div className="no_requests text-center mt-4">
                    <h5>No requests yet</h5>
                  </div>
                ) : (
                  <div className="request-card-wrapper">
                    {isRequested.map((req) => {
                      const isLoading = loadingRequestId === req._id;
                      const profilePic = req?.from?.profilePic
                        ? `${req.from.profilePic}`
                        : "https://cdn-icons-png.flaticon.com/512/149/149071.png";

                      return (
                        <div
                          key={req._id}
                          className="request-card-custom shadow-sm rounded p-3 mb-3 bg-white"
                        >
                          <div className="d-flex align-items-start position-relative">
                            <img
                              src={profilePic}
                              alt="user"
                              className="request-avatar rounded-circle cursor-pointer"
                              width="55"
                              height="55"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/user/${req.from._id}/profile`);
                              }}
                              onError={(e) => {
                                e.target.src =
                                  "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                              }}
                            />

                            <div className="flex-grow-1 ms-3">
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <h6
                                    className="mb-1 fw-bold cursor-pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/user/${req.from._id}/profile`);
                                    }}
                                  >
                                    {req?.from?.fullName}
                                  </h6>

                                  <p className="mb-1 text-muted small">
                                    Wants to send you a message
                                  </p>
                                  <small className="text-secondary">
                                    {req?.messages?.[0]?.text ||
                                      ""}
                                  </small>
                                </div>
                              </div>

                              <div className="d-flex gap-2 mt-3">
                                <button
                                  className="accept-btn w-100 d-flex justify-content-center align-items-center"
                                  disabled={loadingRequestId === req._id}
                                  onClick={() => handleRequestAccepte(req)}
                                >
                                  {loadingRequestId === req._id &&
                                    loadingAction === "accept"
                                    ? "Accepting..."
                                    : "Accept"}
                                </button>

                                <button
                                  className="btn btn-outline-danger w-100 d-flex justify-content-center align-items-center"
                                  disabled={loadingRequestId === req._id}
                                  onClick={() => handleRequestReject(req)}
                                >
                                  {loadingRequestId === req._id &&
                                    loadingAction === "reject"
                                    ? "Rejecting..."
                                    : "Reject"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}

          {(!isMobile || ActiveChat) && (
            <div className="messenger_right">
              {!ActiveChat ? (
                <div className="no-chat-selected">
                  <div className="no-chat-content">
                    <div className="no-chat-icon">💬</div>
                    <h3>Select a chat</h3>
                    <p>
                      Choose a conversation from the list to start messaging
                    </p>
                  </div>
                </div>
              ) : (
                <div className="chat-window">
                  <div className="chat-header">
                    <div className="small_device_chats">
                      {isMobile && ActiveChat && (
                        <button
                          className="back-button-mobile"
                          onClick={() => {
                            setActiveChat(null);
                            navigate("/message", { replace: true });
                          }}
                        >
                          <FontAwesomeIcon icon={faCircleChevronLeft} />
                        </button>
                      )}
                      <div className="chat-user">
                        <div>
                          <div
                            className="chat_user_profile"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (!ActiveChat?.user?._id) return;
                              navigate(`/user/${ActiveChat.user._id}/profile`, {
                                state: {
                                  from: location.pathname,
                                  conversationId: ActiveChat?.conversationId,
                                  chatUserId: ActiveChat?.user?._id,
                                },
                              });
                            }}
                          >
                            <img
                              src={
                                ActiveChat?.user?.profilePic
                                  ? `${ActiveChat.user.profilePic}`
                                  : ProfileImg
                                    ? `${ProfileImg}`
                                    : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                              }
                              alt="profile_img"
                              onError={(e) => {
                                e.target.src =
                                  "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                              }}
                            />
                            <div className="status_section">
                              <h4 className="mb-0">{chatHeaderUser}</h4>
                              {typing && (
                                <span className="status online">Typing...</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="dropdown_user_chat" ref={UserChatDropDown}>
                      <FontAwesomeIcon
                        onClick={() => setisActiveDropDown((prev) => !prev)}
                        icon={faEllipsis}
                      />
                      {isActiveDropDown && (
                        <div className="chat-dropdown-menu">
                          <div
                            onClick={
                              isBlocked ? handleUnBlock : handleBlockChat
                            }
                            className="chat-dropdown-item"
                          >
                            {isBlocked ? "Unblock Chat" : "Block Chat"}
                          </div>

                          <div
                            onClick={() => {
                              if (window.confirm("Delete This Chat")) {
                                handleDeleteChat(ActiveChat?.conversationId);
                              }
                            }}
                            className="chat-dropdown-item report"
                          >
                            Delete Chat
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="chat_container">
                    <div className="chat-messages">
                      {isChats.map((chat) => {
                        const senderId =
                          typeof chat.sender === "object"
                            ? chat.sender._id
                            : chat.sender;

                        const isMyMessage = senderId !== userID;
                        const isSelected = selectedMessages.includes(chat._id);

                        const mediaUrl = chat.image ? `${chat.image}` : null;

                        const isVideo =
                          mediaUrl &&
                          (mediaUrl.endsWith(".mp4") ||
                            mediaUrl.endsWith(".webm") ||
                            mediaUrl.endsWith(".mov"));

                        return (
                          <div
                            key={chat._id || chat.id}
                            className={`message-row ${isMyMessage ? "right" : "left"} ${isSelected ? "selected" : ""
                              }`}
                            onClick={() => {
                              if (selectedMessages.length > 0) {
                                toggleMessageSelection(chat._id);
                              }
                            }}
                            onContextMenu={(e) => {
                              e.preventDefault();
                              toggleMessageSelection(chat._id);
                            }}
                          >
                            <div className="select_delete_message">
                              {mediaUrl && (
                                <div className="position-relative d-inline-block w-100">
                                  {isVideo ? (
                                    <video
                                      src={mediaUrl}
                                      controls
                                      className="img-fluid rounded"
                                      style={{
                                        maxWidth: "260px",
                                        height: "auto",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={mediaUrl}
                                      alt="sent-media"
                                      className="img-fluid rounded"
                                      style={{
                                        maxWidth: "260px",
                                        height: "auto",
                                      }}
                                      loading="lazy"
                                    />
                                  )}
                                </div>
                              )}
                              {chat.text && (
                                <div
                                  className={`message-bubble ${isOnlyEmoji(chat.text)
                                      ? emojiCount(chat.text) === 1
                                        ? "emoji-only"
                                        : emojiCount(chat.text) <= 3
                                          ? "emoji-only multi-emoji"
                                          : "emoji-only many-emoji"
                                      : ""
                                    }`}
                                >
                                  {chat.text}
                                </div>
                              )}

                              {selectedMessages.length > 0 && (
                                <input
                                  type="checkbox"
                                  className="message-checkbox"
                                  checked={isSelected}
                                  onChange={() =>
                                    toggleMessageSelection(chat._id)
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                />
                              )}
                            </div>

                            <span className="msg-time">
                              {new Date(chat.createdAt).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </span>
                          </div>
                        );
                      })}

                      <div ref={messagesEndRef}></div>
                    </div>
                  </div>

                  {isBlocked ? (
                    <div className="can_not_message">
                      <h2>you can not send him message</h2>
                    </div>
                  ) : (
                    <div
                      className="chat-input"
                      style={{ position: "relative" }}
                    >
                      <FaPlus
                        onClick={handleFileClick}
                        style={{ cursor: "pointer" }}
                      />

                      <div className="voice_recording">
                        <MdKeyboardVoice
                          onClick={() => setIsRecordignTOggle((prev) => !prev)}
                          size={20}
                          style={{
                            color: isRecordingToggle ? "#ff3b3b" : "#333",
                          }}
                        />
                      </div>

                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        accept="image/*"
                        onChange={handleFileChange}
                      />

                      {imagePreview && (
                        <div className="inline-preview">
                          <img src={imagePreview} alt="preview" />
                          <span
                            onClick={() => {
                              setSelectedImage(null);
                              setImagePreview(null);
                              if (fileInputRef.current) fileInputRef.current.value = "";
                            }}
                          >
                            ✖
                          </span>
                        </div>
                      )}

                      {!isRecordingToggle && (
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <input
                            type="text"
                            placeholder="Type a message..."
                            value={message}
                            onChange={(e) => handleTyping(e.target.value)}
                            onKeyDown={(e) =>
                              e.key === "Enter" && handleSendChat()
                            }
                            style={{
                              paddingRight: "45px",
                              paddingLeft: "10px",
                              opacity: isRecordingToggle ? 0.6 : 1,
                            }}
                            disabled={false}
                          />

                          <BsEmojiSmile
                            size={22}
                            style={{
                              position: "absolute",
                              right: "12px",
                              cursor: "pointer",
                              color: "#666",
                            }}
                            onClick={() => setShowEmojiPicker((prev) => !prev)}
                          />

                          {showEmojiPicker && (
                            <div
                              ref={emojiRef}
                              className="emoji-container"
                              style={{
                                position: "absolute",
                                bottom: "55px",
                                right: "0",
                                zIndex: 999,
                              }}
                            >
                              <EmojiPicker
                                onEmojiClick={handleEmojiClick}
                                searchDisabled={false}
                                skinTonesDisabled={false}
                                previewConfig={{ showPreview: false }}
                                width="100%"
                                height={400}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {isRecordingToggle && (
                        <div className="recording-bar">
                          <div className="left">
                            <span className="mic-icon">🎙️</span>
                            <span className="recording-text">Recording...</span>
                            <span className="timer">
                              {formatTime(recordingTime)}
                            </span>
                          </div>

                          <div className="recording_actions">
                            <button
                              onClick={() => {
                                setIsRecordignTOggle(false);
                              }}
                              className="cancel-btn"
                            >
                              <MdDeleteOutline size={20} />
                            </button>

                            <button className="stop-btn">
                              {isRecording ? (
                                <FaRegCirclePause
                                  onClick={handlePauseRecording}
                                  size={20}
                                />
                              ) : (
                                <VscDebugStart
                                  onClick={handleStartRecording}
                                  size={20}
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="send_messsage_button">
                        <button onClick={handleSendChat}>Send</button>
                      </div>
                    </div>
                  )}
                  
                  {showChatPopup && (
                    <div
                      className="modal fade show"
                      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.55)" }}
                      tabIndex="-1"
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
                          <div
                            style={{
                              height: "27px",
                              width: "100%",
                              background: "linear-gradient(90deg, #ff8c00, #ff6a00)",
                            }}
                          />

                          <div className="modal-body text-center px-4 py-4">
                            <h5
                              className="fw-bold mb-2"
                              style={{ color: "#ff8c00", fontSize: "20px" }}
                            >
                              Message Not Sent
                            </h5>

                            <p className="text-muted mb-4" style={{ fontSize: "15px" }}>
                              {chatPopupMsg}
                            </p>

                            <button
                              className="btn fw-semibold px-4 py-2"
                              style={{
                                background: "linear-gradient(135deg, #ff8c00, #ff6a00)",
                                color: "#fff",
                                borderRadius: "10px",
                                border: "none",
                                boxShadow: "0 4px 12px rgba(255,122,0,0.3)",
                              }}
                              onClick={() => setShowChatPopup(false)}
                            >
                              Okay
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {selectedMessages.length > 0 && (
                    <div className="message-delete-bar">
                      <span>{selectedMessages.length} message's selected</span>
                      <button
                        className="delete-selected-btn"
                        onClick={handleDeleteMessages}
                      >
                        Delete Selected
                      </button>
                      <button
                        className="cancel-selection-btn"
                        onClick={() => setSelectedMessages([])}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default Message;